<template>
  <router-link :to="{ name: 'LandingPage' }">
    <div
      :class="{
        'logo-space-width': !smallLogo
      }"
    >
      <div
        :class="[
          smallLogo ? 'small-logo-wrapper' : 'large-logo',
          $federation.logo.backgroundColor
        ]"
      >
        <img
          :src="$federation.logo.image"
          :alt="$federation.logo.label"
          role="img"
        />
      </div>
    </div>
  </router-link>
</template>
<script>
export default {
  name: "AppEquestrianDefaultLogo",
  computed: {
    authenticated() {
      return this.$auth && this.$auth.isAuthenticated;
    },
    smallLogo() {
      return this.authenticated || this.$vuetify.breakpoint.smAndDown;
    }
  }
};
</script>
